export function getUrlToPackagesPage () {
  return '/packages'
}

export function getUrlToPostPackagePage () {
  return `${getUrlToPackagesPage()}/post`
}

export function getUrlToListPackagesPage () {
  return getUrlToPackagesPage()
}

export function getUrlToViewPackagePage (id = ':id') {
  return `${getUrlToPackagesPage()}/${id}`
}

export function getUrlToLoginPage () {
  return '/login'
}

export function getUrlToLoginCallbackPage () {
  return '/login/callback'
}

export function getUrlToLogoutPage () {
  return '/logout'
}

export function getUrlToAccountPage (backTo?: string) {
  const base = '/account';
  return backTo ? `${base}?backTo=${backTo}` : base;
}
